<template>
    <v-container class="input-text-size">
      <Loader v-if="loading"/>
      <TaxesTransactionCriteria
      :baseCrudKey="baseCrudKey"
      ref="taxesTransactionCriteria"
      @loadCRUDList="getApportionmentTaxesRecord"
      />
      <CRUDList
            ref="crudList"
            :headers='headers'
            :displayTopPagination="false"
            :canEdit="true"
            :canSave="true"
            :canAdd="true"
            :showDate="false"
            :showTotal="true"
            :canDeleteInDialog="true"
            :dialogHeaderName="dialogHeaderName"
            :baseCrudKey="baseCrudKey"
            :enableFixedHeaders="true"
            :defaultSortBy="defaultSortBy"
            :selectedItems="selectedItems"
            @emitSelectedItem="emitSelectedItem"
            @loadCRUDList="getApportionmentTaxesRecord"
            @upsertItem="upsertTransaction"
            :variableToChangeRowBgColor="[{ varName: 'highlightRow', varCol: '#ffd180' }]"
            :footerTotalDisplayColumnWise="totalOfTaxes"
            tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
            tableDynamicClassname='taxroll-custom-table'
            tableDynamicHeight='250'
            dialogDynamicWidth="600"
            :createNewItem="newItemDialog"
            :loadingData="gridLoading.flag"
            :loadingText="gridLoading.text"
            @deleteItem="deleteFromDiaglog"

           >
           <template v-slot:addidtionalCrudFooter>
           <p v-if="isTrialSelected && hasManualRows" class="pt-2 ml-4" style="color: orange;">
            {{ trialNote }}</p>
           <p v-else-if="!isTrialSelected && showWarningMessage" class="pt-2 ml-4" style="color: orange;">
            Build required for building Manual Records in Apportionment</p>
         </template>
        <template v-slot:[`editedItem`]="{}">
        <ApportionmentTaxesEditedItem
        :baseCrudKey="baseCrudKey"
        />
      </template>

        </CRUDList>
                <div class="flex-btns input-text-size">
                  <div class="apportionment-btns">
                    <v-row class="flex-row">
                      <v-col cols="4" class="input-text-size">
                        <p class="mt-6">Business Date :</p>
                      </v-col>
                      <v-col cols='3'>
                        <ClarionDateControl class="input-text-size" :isToggle="false"
                        v-model="criteriaState.fromDate"
                        label="From Date" @blurred="changeTheCriteriaBusinessFromDate" />
                      </v-col>
                      <v-col cols='4'>
                        <ClarionDateControl class="input-text-size" :isToggle="false"
                        v-model="criteriaState.toDate"
                        label="To Date" @blurred="changeTheCriteriaBusinessToDate" />
                      </v-col>
                    </v-row>
                    <v-row class="mt-n6 flex-row">
                      <v-col cols="4" class="ml-6">
                      <v-btn color="primary" small rounded
                      :disabled="isBuildingRecords"
                      @click="openDailogforTrailRecords">
                        Build Records
                      </v-btn>
                    </v-col>
                      <v-col cols="4" class="ml-6 mt-n1" v-if="isSameDateRange">
                        <v-checkbox
                          v-model="exemptOnly"
                          label="Exempt Only"
                          dense
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="apportionment-btns mt-6 ml-9">
                      <v-row dense>
                        <v-col cols="5">
                        <v-btn color="primary" small rounded @click="printPaymentSummaryReport">
                          Tax District Summary
                        </v-btn>
                      </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="6">
                        <v-btn color="primary" small rounded @click="printCollectionSummaryReport">
                          Collection Summary
                        </v-btn>
                      </v-col>
                        <v-col cols="5">
                      <v-btn color="primary" small rounded @click="printTifBreakdownReport">
                        TIF Breakdown Report
                      </v-btn>
                    </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="6">
                        <v-btn color="primary" small rounded
                        @click="printTaxDistrictBreakdownReport">
                          Tax District Breakdown
                        </v-btn>
                      </v-col>
                        <v-col cols="5">
                      <v-btn color="primary" small rounded @click="printExemptManufacturingReport">
                        Exempt Manufacturing Report
                      </v-btn>
                    </v-col>
                      </v-row>
                  </div>
                </div>
                <!-- Invalid Date Range Dialog -->
                <v-dialog max-width="500" v-model="dialogForInvalidDateRange">
                  <v-card>
                    <v-card-title class="input-text-size error--text">
                      Invalid Date Range
                    </v-card-title>
                    <v-card-text class="input-text-size">
                      <v-alert type="warning" outlined class="mb-3">
                        You can only build apportionment records for a single month.
                        Please change your date range and try again.
                      </v-alert>
                      <p class="mb-3">Would you like to proceed anyway?</p>
                      <div class="d-flex justify-space-around">
                        <v-btn
                          color="blue darken-1"
                          text
                          disabled
                          class="input-text-size"
                        >
                          NORMAL
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          class="input-text-size"
                          :loading="isBuildingRecords"
                          :disabled="isBuildingRecords"
                          @click="proceedWithInvalidRange('trial')"
                        >
                          TRIAL
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          class="input-text-size"
                          :disabled="isBuildingRecords"
                          @click="closeInvalidDateRangeDialog"
                        >
                          Cancel
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <!-- Trail Records Dialog -->
                <v-dialog max-width="400" v-model="dialogforTrailRecords">
                  <v-card>
                    <v-card-title class="input-text-size">
                    Type of Apportionment Records to create
                  </v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="manualOnly"
            label="Manual records only (Trial)"
            dense
            hide-details
            class="input-text-size mt-0"
          />
          <v-btn
            color="blue darken-1"
            text
            class="input-text-size"
            :loading="isBuildingRecords && trialNormalval === 'yes'"
            :disabled="isBuildingRecords"
            @click="createTrailRecordsOrNot('yes')"
          >
            NORMAL
          </v-btn>
          <v-btn
          class="input-text-size"
            color="blue darken-1"
            text
            :loading="isBuildingRecords && trialNormalval === 'no'"
            :disabled="isBuildingRecords"
            @click="createTrailRecordsOrNot('no')"
          >
            TRIAL
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            class="input-text-size"
            :disabled="isBuildingRecords"
            @click="closeDialog"
          >
            Cancel
          </v-btn>
        </v-card-text>
    </v-card>
    </v-dialog>
    <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKeyForUnpostedDatesDialog"
  dialogDynamicWidth="50vw"
  :canSave="false">
    <template v-slot:[`editedItem`]="{ }">
     <p>
    Unposted payments records found within date range, Please post all payments on the following
    dates, and then build records again
     </p>
      {{ handleUnPostedDates() }}
    </template>
      </CRUDDialog>
        <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKeyForPostingPeriodCheck"
  dialogDynamicWidth="50vw"
  :canSave="false"
  :canCancel="false">
    <template v-slot:[`editedItem`]="{ }">
     <p>
Your apportionment date range of {{criteriaState.fromDate}} - {{criteriaState.toDate}}
falls within the current posting period of
{{taxSettingItem.curPostPerFromDate}} - {{taxSettingItem.curPostPerToDate}}.
You must roll your posting period forward to the next month before you do your apportionment.
Please navigate to Payments - Utils - Posting Period and complete
the necessary steps to close out your posting period.
Then you may retry the Build Records step for the apportionment here on this page.
     </p>
    </template>
     <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="onClose">Ok</v-btn>
      </template>
      </CRUDDialog>
    <!-- GL Fund Error Dialog -->
    <v-dialog v-model="showGLFundErrorDialog" max-width="600px" persistent>
      <v-card>
        <v-card-text class="mt-2">
          <!-- {{ currentGLFundError }} -->
          <v-alert type="error" outlined class="mb-2 mt-2">
            <strong class="d-block" style="white-space: pre-line; max-height: 50vh; overflow-y: auto;">{{ currentValidationHeadline || ''}}</strong>
          </v-alert>
          <div v-if="currentGLFundError">
            <h4 class="mb-3">
              Record Details ({{ currentErrorIndex + 1 }} of {{ glFundErrorArray.length }}):
            </h4>
            <!-- Debug info - always show for now to help troubleshoot -->
            <!-- <div class="mb-3 pa-2" style="background-color: #f5f5f5; border: 1px solid #ddd;">
              <strong>Debug Info:</strong>
              <pre style="font-size: 12px;">{{ JSON.stringify(debugErrorInfo, null, 2) }}</pre>
            </div> -->
            <v-simple-table dense>
              <tbody>
                  <tr v-if="currentGLFundError.taxYear">
                  <td><strong>Tax Year:</strong></td>
                  <td class="error--text">{{ (currentGLFundError.taxYear || 'MISSING') }}</td>
                </tr>
                  <tr v-if="currentGLFundError.taxDistrict">
                  <td><strong>Tax District:</strong></td>
                  <td class="error--text">{{ (currentGLFundError.taxDistrict || 'MISSING') }}</td>
                </tr>
                <tr>
                  <td><strong>Amount:</strong></td>
                  <td class="error--text">
                    {{ formatCurrencyForDisplay(currentGLFundError.amount || 'MISSING') }}</td>
                </tr>
                <tr>
                  <td><strong>Section:</strong></td>
                  <td class="error--text">{{ currentGLFundError.section || 'MISSING' }}</td>
                </tr>
                <tr>
                  <td><strong>Source No:</strong></td>
                  <td class="error--text">{{ currentGLFundError.sourceNo || 'MISSING' }}</td>
                </tr>
                <tr>
                  <td><strong>Source Description:</strong></td>
                  <td class="error--text">{{ currentGLFundError.sourceDesc || 'MISSING' }}</td>
                </tr>
               <tr>
                  <td><strong>Tax Unit:</strong></td>
                  <td class="error--text">{{ currentGLFundError.unit || 'MISSING'}}</td>
                </tr>
                 <tr>
                  <td><strong>Unit Fund:</strong></td>
                  <td class="error--text">{{ currentGLFundError.fund || 'MISSING' }}</td>
                </tr>
                <tr></tr>
                <tr>
                  <td><strong>GL Fund:</strong></td>
                  <td class="error--text">{{ currentGLFundError.fundNo || 'MISSING' }}</td>
                </tr>
                <tr>
                  <td><strong>Fund Description:</strong></td>
                  <td class="error--text">{{ currentGLFundError.fundDesc || 'MISSING' }}</td>
                </tr>
                <tr>
                  <td><strong>Money From :</strong></td>
                  <td class="error--text">{{  currentGLFundError.moneyFrom || 'MISSING'}}</td>
                </tr>
                 <tr>
                  <td><strong>Alt Key :</strong></td>
                  <td class="error--text">{{  currentGLFundError.tag.altKey || 'MISSING'}}</td>
                </tr>
                <tr>
                  <td><strong>Fee Number :</strong></td>
                  <td class="error--text">{{  currentGLFundError.feeNumber || 'MISSING'}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="hasMoreErrors"
            color="primary"
            text
            @click="showNextError"
          >
            <v-icon left>mdi-arrow-right</v-icon>
            Continue ({{ currentErrorIndex + 1 }}/{{ glFundErrorArray.length }})
          </v-btn>
          <v-btn
            v-else
            color="primary"
            text
            :loading="isBuildingRecords"
            :disabled="isBuildingRecords"
            @click="handleGLFundError('continue')"
          >
            <v-icon left>mdi-check</v-icon>
            Continue
          </v-btn>
          <v-btn
            color="warning"
            text
            :disabled="isBuildingRecords"
            @click="handleGLFundError('skip')"
          >
            Skip
          </v-btn>
          <v-btn color="error" text :disabled="isBuildingRecords" @click="handleGLFundError('abort')">
            <v-icon left>mdi-close</v-icon>
            Abort
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Negative Collections Dialog -->
    <v-dialog v-model="showNegativeCollectionsDialog" max-width="600px">
      <v-card>
        <v-card-title class="input-text-size">
          Negative Collections Found
        </v-card-title>
        <v-card-text>
          <div style="max-height: 300px; overflow-y: auto;">
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Tax Year</th>
                  <th>Tax District</th>
                  <th>Tax Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in negativeCollectionsList" :key="index">
                  <td>{{ row.taxYear }}</td>
                  <td>{{ row.schoolDistrict }}</td>
                  <td class="error--text">{{ formatCurrencyForDisplay(row.taxAmt) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <v-alert type="warning" outlined class="mt-4 mb-0">
            {{ negativeCollectionsMessage }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeNegativeCollectionsDialog">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
</template>

<script>
import {
  mapGetters, mapMutations, mapState, mapActions,
} from 'vuex';
import { taxesTransactionListHeaders } from '../apportionmentutils/apportionmentTableHeader';
import { makeCriteriaStateNullIfEmptyString } from '../../tax/common-utils/CommonTaxFunctionalities';
import {
  amountFormat, amountToNumber, defaultGridLoading, manageGridLoading,
} from '../../../util/shared/vue-global';
import {
  toIsoDate,
  toShortDate,
  getDefaultMonthRange,
  toStandardDate,
} from '../../../util/shared/tmc-global';
import { generateQueryString } from '../../common/base/report/report-util';
import { clients } from '../../../util/clients';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import TaxesTransactionCriteria from './taxesTransactionCriteria.vue';
import ApportionmentTaxesEditedItem from './apportionmentTaxesEditedItem.vue';
import { TRIAL_BUILD_NOTE, buildUpsertItem, shouldConfirmTrialBuild } from './taxes.Utils';
import Loader from '../../tax/common-utils/loader.vue';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import '../../../assets/style.css';

const { backendRest } = clients.direct;

export default {
  name: 'apportionment',
  data() {
    // Use shared utility for default month range
    const { fromDateValue, toDateValue } = getDefaultMonthRange();
    return {
      headers: taxesTransactionListHeaders,
      gridLoading: defaultGridLoading(),
      baseCrudKey: 'taxesApprotionment',
      dialogforTrailRecords: false,
      dialogForInvalidDateRange: false,
      isTrail: false,
      loading: false,
      // True from the click until the build returns; a second build would duplicate the records.
      isBuildingRecords: false,
      dialogHeaderName: 'TAX APPORTIONMENT RECORD',
      // dialogForLockedRecords: false,
      baseCrudKeyForUnpostedDatesDialog: 'baseCrudKeyForUnposted',
      baseCrudKeyForPostingPeriodCheck: 'baseCrudKeyForPostingPeriodCheck',
      showGLFundErrorDialog: false,
      glFundErrorData: null,
      glFundErrorArray: [],
      currentErrorIndex: 0,
      validationHeadline: null,
      pendingTrailRecordsCall: null,
      showNegativeCollectionsDialog: false,
      negativeCollectionsList: [],
      negativeCollectionsMessage: 'Negative collections in a single year and tax district do not necessarily pose a problem.  All tax years collections are totaled, and often multiple tax districts are combined into one remit unit.  Examine your report totals closely to ensure that you do not actually have a negative apportionment amount going to a fund or remit unit.',
      showWarningMessage: false,
      hasManualRows: false,
      manualOnly: false,
      trialNote: TRIAL_BUILD_NOTE,
      totalOfTaxes: [null, null, 'Total :', null, null, null, null, null, null],
      trialNormalval: '',
      exemptOnly: false,
      // Default for UI date controls
      initialFromDate: fromDateValue,
      initialToDate: toDateValue,
    };
  },
  components: {
    CRUDList,
    ClarionDateControl,
    TaxesTransactionCriteria,
    ApportionmentTaxesEditedItem,
    Loader,
    CRUDDialog,
  },
  created() {
    this.loadConfig({ requiredScope: 'taxConfig' });
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item']),
    isTrialSelected() {
      return this.criteriaState.typeOfRecord === true;
    },
    criteriaState: {
      get() {
        // If fromDate/toDate are not set, prepopulate them
        const state = this.criteria(this.baseCrudKey);
        if (!state.fromDate) {
          state.fromDate = this.initialFromDate;
        }
        if (!state.toDate) {
          state.toDate = this.initialToDate;
        }
        return state;
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    criteriaStateForMiscMtg: {
      get() {
        return this.criteria('miscMtgBaseCrudKey');
      },
      set(value) {
        this.setCriteria(['miscMtgBaseCrudKey', value]);
      },
    },
    criteriaStateForApportionment: {
      get() {
        return this.criteria('approtionmentTab');
      },
      set(value) {
        this.setCriteria(['approtionmentTab', value]);
      },
    },
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      storeSelItems:
      (state) => state.apportionment.apportionmentTaxes.selectedItems || [],
      lockedRecordsCount: (state) => state.apportionment.apportionmentTaxes.totalLockedRecordsCount,
      unPostedRecords: (state) => state.apportionment.apportionmentTaxes.unpostedRecords,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
    }),
    selectedItems: {
      get() {
        return this.storeSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    lockedRecordsCounts: {
      get() {
        return this.lockedRecordsCount;
      },
      set(value) {
        this.setTotalLockedRecordsCount(value);
      },
    },
    unPostedRecordsInPayments: {
      get() {
        return this.unPostedRecords;
      },
      set(value) {
        this.setUnpostedRecords(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
        {
          column: 'schoolDistrict',
          direction: 'asc',
        },
      ];
    },
    currentGLFundError() {
      const hasErrors = this.glFundErrorArray.length > 0;
      const validIndex = this.currentErrorIndex < this.glFundErrorArray.length;
      if (hasErrors && validIndex) {
        const currentError = this.glFundErrorArray[this.currentErrorIndex];
        // Handle nested structure where actual record data is in recordData property
        if (currentError && currentError.recordData) {
          return currentError.recordData;
        }
        return currentError;
      }
      return this.glFundErrorData; // Fallback for backward compatibility
    },
    hasMoreErrors() {
      return this.currentErrorIndex < this.glFundErrorArray.length - 1;
    },
    debugErrorInfo() {
      return {
        glFundErrorArrayLength: this.glFundErrorArray.length,
        currentErrorIndex: this.currentErrorIndex,
        currentError: this.currentGLFundError,
        hasErrors: this.glFundErrorArray.length > 0,
      };
    },
    currentValidationHeadline() {
      const hasErrors = this.glFundErrorArray.length > 0;
      const validIndex = this.currentErrorIndex < this.glFundErrorArray.length;
      if (hasErrors && validIndex) {
        const currentError = this.glFundErrorArray[this.currentErrorIndex];
        return currentError.message || this.validationHeadline;
      }
      return this.validationHeadline;
    },
    isSameDateRange() {
      const { fromDate, toDate } = this.criteriaState;
      return fromDate && toDate && fromDate === toDate;
    },
  },
  watch: {
    isSameDateRange(newVal) {
      this.exemptOnly = newVal;
    },
  },
  methods: {
    ...mapActions(['reAuth', 'flashWarn']),
    ...mapActions(['reAuth', 'flashError']),
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapMutations('base/crud', [
      'setCriteria', 'setItems', 'setIsVisible',
    ]),
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.$emit('loadCRUDList');
    },
    manageGridLoading,
    ...mapMutations('apportionment/apportionmentTaxes', [
      'setSelectedItems',
      'setTotalLockedRecordsCount',
      'setUnpostedRecords',
    ]),
    ...mapActions('apportionment/apportionmentTaxes', [
      'loadapportionmenttaxesData',
      'taxesApportionmnetCollectRecords',
      'upsertTaxApportionmentRecord',
      'taxesApportionmnetCountForLockedRecords',
      'taxesApportionmnetCheckForUnPostedRecords',
      'apportionmenttaxesTotals',
      'deleteApportionmnetaxesRecord',
    ]),
    ...mapActions('apportionment/apportionmentTab', [
      'deleteRecordFromApportionment',
    ]),
    async getApportionmentTaxesRecord(fromWhere) {
      const { baseCrudKey } = this;
      const criteria = {
        ...this.criteriaState,
        fromDateValue: this.criteriaState.fromDateValue
          ? toIsoDate(this.criteriaState.fromDateValue) : null,
        toDateValue: this.criteriaState.toDateValue
          ? toIsoDate(this.criteriaState.toDateValue) : null,
        fromDate: this.criteriaState.fromDate
          ? toIsoDate(this.criteriaState.fromDate) : null,
        toDate: this.criteriaState.toDate
          ? toIsoDate(this.criteriaState.toDate) : null,
        exemptOnly: this.exemptOnly,
      };
      manageGridLoading(this, true, 'Searching...');
      const totalData = await this.apportionmenttaxesTotals({ criteria });
      if (totalData.length > 0) {
        const total = totalData[0];
        this.totalOfTaxes = [null, null, 'Total :', null, amountFormat(total.totalTaxAmount), amountFormat(total.totalPenalty), amountFormat(total.totalFees), amountFormat(total.totalofAll)];
      } else {
        this.totalOfTaxes = [null, null, 'Total :', null, amountFormat(0.00), amountFormat(0.00), amountFormat(0.00), amountFormat(0.00), null];
      }
      try {
        const res = await this.loadapportionmenttaxesData(
          { criteria, baseCrudKey, postProcessTrans: this.postProcessAppData },
        );
        const manualRecordstoHighlight = res.filter((item) => item.highlightRow);
        this.hasManualRows = res.some((item) => item.isManualRecord || item.highlightRow);
        if (manualRecordstoHighlight.length > 0) {
          this.showWarningMessage = true;
        } else {
          this.showWarningMessage = false;
        }

        if (fromWhere === 'fromBuildRecords') {
          this.$refs.taxesTransactionCriteria.callFromParentToUpdateDate();
        }
      } catch (error) {
        console.error('Error loading apportionment taxes data:', error);
      } finally {
        manageGridLoading(this, false);
      }
      // this.$nextTick(() => {
      //   this.criteriaState.fromDateValue = this.criteriaState.fromDate;
      //   this.criteriaState.toDateValue = this.criteriaState.toDate;
      // });
    },
    openDailogforTrailRecords() {
      if (this.isValidDateRange(toIsoDate(this.criteriaState.fromDate),
        toIsoDate(this.criteriaState.toDate))) {
        this.manualOnly = false;
        this.dialogforTrailRecords = true;
      } else {
        this.dialogForInvalidDateRange = true;
      }
    },
    async upsertTransaction(item) {
      const businessDate = item.businessDate ? toIsoDate(item.businessDate) : null;
      const { baseCrudKey } = this;
      // For manual records, postProcessAppData overwrites fromDate/toDate with
      // businessDate for display. On re-save, use the criteria date range so the
      // record keeps matching the filter and doesn't "disappear".
      let fromDate = null;
      if (this.criteriaState.fromDateValue) {
        fromDate = toIsoDate(this.criteriaState.fromDateValue);
      } else if (item.fromDate) {
        fromDate = toIsoDate(item.fromDate);
      }
      let toDate = null;
      if (this.criteriaState.toDateValue) {
        toDate = toIsoDate(this.criteriaState.toDateValue);
      } else if (item.toDate) {
        toDate = toIsoDate(item.toDate);
      }
      const updatedItem = buildUpsertItem({
        item, fromDate, toDate, businessDate,
      });
      updatedItem.taxAmt = amountToNumber(updatedItem.taxAmt);
      updatedItem.penaltyAmount = amountToNumber(updatedItem.penaltyAmount);
      updatedItem.totalFees = amountToNumber(updatedItem.totalFees);
      updatedItem.totalAmount = amountToNumber(updatedItem.totalAmount);
      updatedItem.grossAssessed = amountToNumber(updatedItem.grossAssessed);
      updatedItem.isManualRecord = true;
      updatedItem.highlightRow = true; // Highlight the row for manual records
      const response = await this.upsertTaxApportionmentRecord({ item: updatedItem, baseCrudKey });
      this.getApportionmentTaxesRecord();
      return response;
    },
    async createTrailRecordsOrNot(val) {
      if (this.isBuildingRecords) return;
      this.isBuildingRecords = true;
      try {
        await this.buildTrailRecords(val);
      } finally {
        this.isBuildingRecords = false;
      }
    },
    async buildTrailRecords(val) {
      this.trialNormalval = val;
      const initialCriteria = {
        ...this.criteriaState,
        fromDateValue: this.criteriaState.fromDateValue
          ? toIsoDate(this.criteriaState.fromDateValue) : null,
        toDateValue: this.criteriaState.toDateValue
          ? toIsoDate(this.criteriaState.toDateValue) : null,
        fromDate: this.criteriaState.fromDate
          ? toIsoDate(this.criteriaState.fromDate) : null,
        toDate: this.criteriaState.toDate
          ? toIsoDate(this.criteriaState.toDate) : null,
        exemptOnly: this.exemptOnly,
      };
      if (val === 'no') {
        // Without "Manual records only", Build also pulls collected taxes into the trial.
        if (shouldConfirmTrialBuild({
          manualOnly: this.manualOnly,
          isTrialSelected: this.isTrialSelected,
          hasManualRows: this.hasManualRows,
        }) && !window.confirm('This will add collected tax records to your trial. Continue?')) {
          return;
        }
        const description = toIsoDate(this.todaysDate);
        this.loading = true;
        this.dialogforTrailRecords = false;
        try {
          const result = await this.taxesApportionmnetCollectRecords({
            criteria: {
              ...initialCriteria,
              isTrialRecord: true,
              manualOnly: this.manualOnly,
              description,
              checkValidation: true,
            },
          });

          this.loading = false;
          this.showNegativeCollectionsIfAny(result);
        } catch (error) {
          this.loading = false;
          if (error.message === 'VALIDATION_ERROR') {
            // Store the pending call for later execution if user chooses to continue
            this.pendingTrailRecordsCall = {
              criteria: {
                ...initialCriteria,
                isTrialRecord: true,
                manualOnly: this.manualOnly,
                description,
              },
            };
            this.setupGLFundErrorData(error);
            this.validationHeadline = error.headline;
            this.showGLFundErrorDialog = true;
            return; // Don't proceed with the rest of the method
          }
          // Re-throw other errors
          throw error;
        }
      } else {
        await this.taxesApportionmnetCountForLockedRecords({ criteria: initialCriteria });
        if (this.lockedRecordsCount > 0) {
          // this.dialogForLockedRecords = true;
          alert(`You must unlock all Tax Apportionment records for the date range ${this.criteriaState.fromDate} - ${this.criteriaState.toDate} before building records again.`);
        } else {
          const postPerToDate = new Date(this.taxSettingItem.curPostPerToDate);
          const criteriaToDate = new Date(this.criteriaState.toDate);
          if (criteriaToDate >= postPerToDate) {
            this.setIsVisible([this.baseCrudKeyForPostingPeriodCheck, true]);
            this.dialogforTrailRecords = false;
            // this.dialogforTrailRecords = false;
            return;
          }
          await this.taxesApportionmnetCheckForUnPostedRecords({ criteria: initialCriteria });
          if (((this.unPostedRecordsInPayments || {}).unPostedDates || []).length > 0) {
          // if (this.unPostedRecordsInPayments?.unPostedDates?.length > 0) {
            this.setIsVisible([this.baseCrudKeyForUnpostedDatesDialog, true]);
          } else {
            this.loading = true;
            this.dialogforTrailRecords = false;
            try {
              const result = await this.taxesApportionmnetCollectRecords({
                criteria: {
                  ...initialCriteria,
                  isNormalRecord: true,
                  checkValidation: true,
                },
              });
              this.exemptOnly = false;
              this.loading = false;
              this.showNegativeCollectionsIfAny(result);
            } catch (error) {
              this.loading = false;
              if (error.message === 'VALIDATION_ERROR') {
                // Store the pending call for later execution if user chooses to continue
                this.pendingTrailRecordsCall = {
                  criteria: {
                    ...initialCriteria,
                    isNormalRecord: true,
                    checkValidation: true,
                  },
                };
                this.setupGLFundErrorData(error);
                this.validationHeadline = error.headline;
                this.showGLFundErrorDialog = true;
                return; // Don't proceed with the rest of the method
              }
              // Re-throw other errors
              throw error;
            }
          }
        }
      }
      this.dialogforTrailRecords = false;
      // this.criteriaState.fromDateValue = this.criteriaState.fromDate;
      // this.criteriaState.toDateValue = this.criteriaState.toDate;
      this.getApportionmentTaxesRecord('fromBuildRecords');
    },
    closeDialog() {
      this.dialogforTrailRecords = false;
    },
    closeInvalidDateRangeDialog() {
      this.dialogForInvalidDateRange = false;
    },
    proceedWithInvalidRange(type) {
      this.dialogForInvalidDateRange = false;
      if (type === 'trial') {
        // Proceed with trial record creation despite invalid date range
        this.createTrailRecordsOrNot('no');
      }
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    isValidDateRange(fromDate, toDate) {
      const from = new Date(`${fromDate}T00:00:00Z`);
      const to = new Date(`${toDate}T00:00:00Z`);
      const sameMonthAndYear = from.getUTCMonth() === to.getUTCMonth()
    && from.getUTCFullYear() === to.getUTCFullYear();
      const timeDifference = Math.abs(to - from);
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
      return sameMonthAndYear && daysDifference <= 31;
    },
    isValidDateForApiCall(dateString) {
      // Check if date string is not empty and not null/undefined
      if (!dateString || dateString.trim() === '') {
        return false;
      }

      // Check if it's a valid date
      const date = new Date(dateString);
      const isValidDate = !Number.isNaN(date.getTime());

      // Additional check for common incomplete date formats
      // This prevents API calls when user is still typing (like "01/", "01/15", etc.)
      const datePattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/; // MM/DD/YYYY or M/D/YYYY format
      const isCompleteFormat = datePattern.test(dateString.trim());

      return isValidDate && isCompleteFormat;
    },
    handleUnPostedDates() {
      const val1 = this.unPostedRecordsInPayments.unPostedDates.map((ft) => (ft ? `${ft}\n` : ''));
      return [...val1].join('');
    },
    postProcessAppData(items) {
      const updatedItems = [];

      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        if (item.isManualRecord === true) {
          item.fromDate = item.businessDate;
          item.toDate = item.businessDate;
        }
        updatedItems.push(item);
      }

      return updatedItems;
    },

    async printPaymentSummaryReport() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/apportionmnet/paymentSummary${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printTaxDistrictBreakdownReport() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/apportionmnet/taxDistrictBreakdown${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printCollectionSummaryReport() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/apportionmnet/collection-summary${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printTifBreakdownReport() {
      if (this.isFiltersAvailable()) {
        const params = await this.getParamsData();
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/apportionmnet/tif-breakdown${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    async printExemptManufacturingReport() {
      if (this.isFiltersAvailable()) {
        const { jwt } = await this.reAuth();
        const getcriteria = {
          ...this.criteriaState,
        };
        const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.criteriaState.fromDateValue && this.criteriaState.toDateValue) {
          params.push(`fromDate=${toShortDate(this.criteriaState.fromDateValue)}`);
          params.push(`toDate=${toShortDate(this.criteriaState.toDateValue)}`);
        }
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/tax/exemptMfg-report${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select date range!');
      }
    },
    isFiltersAvailable() {
      return (this.criteriaState.fromDateValue && this.criteriaState.toDateValue);
    },
    async getParamsData() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const params = [];
      if (this.criteriaState.fromDateValue && this.criteriaState.toDateValue) {
        params.push(`fromDate=${toShortDate(this.criteriaState.fromDateValue)}`);
        params.push(`toDate=${toShortDate(this.criteriaState.toDateValue)}`);
      } else {
        params.push(`fromDate=${toShortDate(new Date())}`);
        params.push(`toDate=${toShortDate(new Date())}`);
      }
      params.push(`isPrintTrial=${(this.criteriaState || {}).typeOfRecord || false}`);
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      params.push(`token=${jwt}`);
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      params.push(`filters=${encodedCriteria}`);
      return params;
    },
    setupGLFundErrorData(errorData) {
      // Handle the nested error structure from the debug data
      if (errorData && errorData.recordData && errorData.recordData.invalidRecords
          && Array.isArray(errorData.recordData.invalidRecords)) {
        // Extract invalidRecords from the nested structure
        this.glFundErrorArray = errorData.recordData.invalidRecords;
        this.currentErrorIndex = 0;
        this.glFundErrorData = this.glFundErrorArray.length > 0 ? this.glFundErrorArray[0] : null;
      } else if (errorData && errorData.invalidRecords && Array.isArray(errorData.invalidRecords)) {
        // Handle the case where invalidRecords is directly on errorData
        this.glFundErrorArray = errorData.invalidRecords;
        this.currentErrorIndex = 0;
        this.glFundErrorData = this.glFundErrorArray.length > 0 ? this.glFundErrorArray[0] : null;
      } else if (Array.isArray(errorData)) {
        // Handle direct array case (backward compatibility)
        this.glFundErrorArray = errorData;
        this.currentErrorIndex = 0;
        this.glFundErrorData = errorData.length > 0 ? errorData[0] : null;
      } else {
        // Handle single object case (backward compatibility)
        this.glFundErrorArray = errorData ? [errorData] : [];
        this.currentErrorIndex = 0;
        this.glFundErrorData = errorData;
      }
    },
    showNextError() {
      if (this.hasMoreErrors) {
        this.currentErrorIndex += 1;
      }
    },
    handleGLFundError(action) {
      if (action === 'continue' || action === 'skip') {
        // User chose to continue despite the error
        this.showGLFundErrorDialog = false;
        this.resetGLFundErrorData();

        // If there's a pending call, execute it
        if (this.pendingTrailRecordsCall) {
          this.executePendingTrailRecordsCall();
        }
      } else {
        // User chose to abort
        this.showGLFundErrorDialog = false;
        this.resetGLFundErrorData();
        this.pendingTrailRecordsCall = null;
        this.loading = false;
      }
    },
    resetGLFundErrorData() {
      this.glFundErrorData = null;
      this.glFundErrorArray = [];
      this.currentErrorIndex = 0;
      this.validationHeadline = null;
    },
    async executePendingTrailRecordsCall() {
      if (!this.pendingTrailRecordsCall || this.isBuildingRecords) return;

      this.isBuildingRecords = true;
      try {
        this.loading = true;
        let criteria = {};
        if (this.trialNormalval === 'no') {
          criteria = {
            ...this.criteriaState,
            fromDateValue: this.criteriaState.fromDateValue
              ? toIsoDate(this.criteriaState.fromDateValue) : null,
            toDateValue: this.criteriaState.toDateValue
              ? toIsoDate(this.criteriaState.toDateValue) : null,
            fromDate: this.criteriaState.fromDate
              ? toIsoDate(this.criteriaState.fromDate) : null,
            toDate: this.criteriaState.toDate
              ? toIsoDate(this.criteriaState.toDate) : null,
            isTrialRecord: true,
            manualOnly: this.manualOnly,
            checkValidation: false,
          };
        } else {
          criteria = {
            ...this.criteriaState,
            fromDateValue: this.criteriaState.fromDateValue
              ? toIsoDate(this.criteriaState.fromDateValue) : null,
            toDateValue: this.criteriaState.toDateValue
              ? toIsoDate(this.criteriaState.toDateValue) : null,
            fromDate: this.criteriaState.fromDate
              ? toIsoDate(this.criteriaState.fromDate) : null,
            toDate: this.criteriaState.toDate
              ? toIsoDate(this.criteriaState.toDate) : null,
            isNormalRecord: true,
            checkValidation: false,

          };
        }
        const result = await this.taxesApportionmnetCollectRecords({ criteria });
        this.exemptOnly = false;
        this.loading = false;
        this.dialogforTrailRecords = false;
        // this.criteriaState.fromDateValue = this.criteriaState.fromDate;
        // this.criteriaState.toDateValue = this.criteriaState.toDate;
        this.getApportionmentTaxesRecord('fromBuildRecords');
        this.showNegativeCollectionsIfAny(result);
      } catch (error) {
        this.loading = false;
        // Handle any other errors that might occur
        console.error('Error in executePendingTrailRecordsCall:', error);
      } finally {
        this.pendingTrailRecordsCall = null;
        this.isBuildingRecords = false;
      }
    },
    formatDateForDisplay(dateString) {
      if (!dateString) return 'N/A';
      try {
        return toStandardDate(dateString) || dateString;
      } catch (error) {
        return dateString;
      }
    },
    showNegativeCollectionsIfAny(result) {
      const negativeCollections = (result && result.negativeCollections) || [];
      if (negativeCollections.length > 0) {
        this.negativeCollectionsList = negativeCollections;
        this.showNegativeCollectionsDialog = true;
      }
    },
    closeNegativeCollectionsDialog() {
      this.showNegativeCollectionsDialog = false;
      this.negativeCollectionsList = [];
    },
    formatCurrencyForDisplay(amount) {
      if (amount === null || amount === undefined) return 'N/A';
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(amount);
      } catch (error) {
        return amount.toString();
      }
    },
    changeTheCriteriaBusinessFromDate() {
      this.criteriaStateForMiscMtg.fromBusinessDateValue = this.criteriaState.fromDate;
      this.criteriaStateForMiscMtg.fromDate = this.criteriaState.fromDate;
      this.criteriaStateForApportionment.fromDate = this.criteriaState.fromDate;

      // Only call API if both dates are complete and valid
      if (this.isValidDateForApiCall(this.criteriaState.fromDate)
          && this.isValidDateForApiCall(this.criteriaState.toDate)) {
        this.getApportionmentTaxesRecord();
      }
    },
    changeTheCriteriaBusinessToDate() {
      this.criteriaStateForMiscMtg.toBusinessDateValue = this.criteriaState.toDate;
      this.criteriaStateForMiscMtg.toDate = this.criteriaState.toDate;
      this.criteriaStateForApportionment.toDate = this.criteriaState.toDate;

      // Only call API if both dates are complete and valid
      if (this.isValidDateForApiCall(this.criteriaState.fromDate)
          && this.isValidDateForApiCall(this.criteriaState.toDate)) {
        this.getApportionmentTaxesRecord();
      }
    },
    async deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        await this.deleteApportionmnetaxesRecord({ item, baseCrudKey });
        this.getApportionmentTaxesRecord();
        this.setIsVisible([baseCrudKey, false]);
      }
    },
    onClose() {
      this.setIsVisible([this.baseCrudKeyForPostingPeriodCheck, false]);
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        fromDate: this.criteriaState.fromDateValue || '',
        toDate: this.criteriaState.toDateValue || '',
        recordType: 'NORMALRECORD',
        description: '',
        grossAssessed: '',
        isExempt: false,
        isLocked: false,
        penaltyAmount: '',
        schoolDistrict: '',
        taxAmt: '',
        taxYear: '',
        totalAmount: '',
        totalFees: '',
      };
      return newItem;
    },
  },
};
</script>
<style scoped>
.flex-btns {
  display: flex;
  flex-direction: row;
}

.flex-row {
  display: flex;
  justify-content: center;
}
.align-right {
  display: flex;
  justify-content: end;
  /* margin-top: 1rem; */
}
</style>
